<!--
 * @Author: 王耀民
 * @Date: 2022/3/28 10:25
 * @Description: 视频放大播放弹窗
-->
<template>
  <el-dialog
    :visible="dialogVisible"
    width="1240px"
    :before-close="handleClose"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
    class="video-player-container"
  >
    <div class="video-player">
      <video :src="url" :controls="controls" :autoplay="autoplay"></video>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "VideoPreview",
  props: {
    controls: {
      type: Boolean,
      default: true,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      url: '',
    }
  },
  methods: {
    open(url) {
      this.dialogVisible = true
      this.url = url
    },
    handleClose() {
      this.dialogVisible = false
    }
  },
}
</script>

<style lang="scss" scoped>
.video-player-container {
  /deep/ .el-dialog {
    margin-top: 5vh !important;
  }
  /deep/ .el-dialog__body {
    border-top: none !important;
  }

  .video-player {
    height: 705px;

    > video {
      width: 100%;
      height: 100%;
      outline: none;
    }
  }
}
</style>
